const API_URL =
  process.env.NEXT_PUBLIC_ENV === "production"
    ? "https://api.rooph.io/api/v1"
    : process.env.NEXT_PUBLIC_ENV === "staging"
    ? "https://staging-api.rooph.io/api/v1"
    : "http://localhost:3001/api/v1";

export default API_URL;
